import React from "react";
import {useTranslation} from "react-i18next";

export function NotDefined() {
    const {t} = useTranslation();

    return (
        <span className={'not-defined'}>
            {t('general.notDefined')}
        </span>
    )
}
